var map = {
	"./Afghanistan.png": 8812,
	"./Albania.png": 8990,
	"./Algeria.png": 2115,
	"./American_Samoa.png": 7590,
	"./Andorra.png": 1413,
	"./Angola.png": 302,
	"./Anguilla.png": 9151,
	"./Antigua_and_Barbuda.png": 5157,
	"./Argentina.png": 8197,
	"./Armenia.png": 7943,
	"./Aruba.png": 8803,
	"./Australia.png": 8308,
	"./Austria.png": 2943,
	"./Azerbaijan.png": 5483,
	"./Bahamas.png": 5201,
	"./Bahrain.png": 7705,
	"./Bangladesh.png": 3,
	"./Barbados.png": 8866,
	"./Belarus.png": 3666,
	"./Belgium.png": 7325,
	"./Belize.png": 9517,
	"./Benin.png": 384,
	"./Bermuda.png": 8046,
	"./Bhutan.png": 3404,
	"./Bolivia.png": 590,
	"./Bosnia.png": 2416,
	"./Botswana.png": 9705,
	"./Brazil.png": 186,
	"./British_Virgin_Islands.png": 6168,
	"./Brunei.png": 9275,
	"./Bulgaria.png": 1403,
	"./Burkina_Faso.png": 3310,
	"./Burundi.png": 3189,
	"./Cambodia.png": 7246,
	"./Cameroon.png": 6112,
	"./Canada.png": 9006,
	"./Cape_Verde.png": 6598,
	"./Cayman_Islands.png": 2596,
	"./Central_African_Republic.png": 8025,
	"./Chad.png": 9870,
	"./Chile.png": 513,
	"./China.png": 9535,
	"./Christmas_Island.png": 4492,
	"./Colombia.png": 8850,
	"./Comoros.png": 8352,
	"./Cook_Islands.png": 3131,
	"./Costa_Rica.png": 2792,
	"./Croatia.png": 5525,
	"./Cuba.png": 971,
	"./Cyprus.png": 6806,
	"./Cyprus_Northern.png": 141,
	"./Czech_Republic.png": 9240,
	"./Côte_d'Ivoire.png": 2952,
	"./Democratic_Republic_of_the_Congo.png": 9695,
	"./Denmark.png": 9992,
	"./Djibouti.png": 5566,
	"./Dominica.png": 9014,
	"./Dominican_Republic.png": 9035,
	"./Ecuador.png": 7543,
	"./Egypt.png": 5143,
	"./El_Salvador.png": 7426,
	"./Equatorial_Guinea.png": 59,
	"./Eritrea.png": 8396,
	"./Estonia.png": 9007,
	"./Ethiopia.png": 3909,
	"./Falkland_Islands.png": 7116,
	"./Faroe_Islands.png": 5970,
	"./Fiji.png": 6240,
	"./Finland.png": 2726,
	"./France.png": 9182,
	"./French_Polynesia.png": 4167,
	"./Gabon.png": 7023,
	"./Gambia.png": 2971,
	"./Georgia.png": 1074,
	"./Germany.png": 2965,
	"./Ghana.png": 6323,
	"./Gibraltar.png": 7818,
	"./Greece.png": 9809,
	"./Greenland.png": 676,
	"./Grenada.png": 3676,
	"./Guam.png": 7346,
	"./Guatemala.png": 6249,
	"./Guinea.png": 7283,
	"./Guinea_Bissau.png": 6759,
	"./Guyana.png": 7305,
	"./Haiti.png": 38,
	"./Honduras.png": 408,
	"./Hong_Kong.png": 8252,
	"./Hungary.png": 3356,
	"./Iceland.png": 4128,
	"./India.png": 5227,
	"./Indonesia.png": 1172,
	"./Iran.png": 8144,
	"./Iraq.png": 1239,
	"./Ireland.png": 1371,
	"./Israel.png": 3472,
	"./Italy.png": 5547,
	"./Jamaica.png": 8916,
	"./Japan.png": 3918,
	"./Jordan.png": 1490,
	"./Kazakhstan.png": 2198,
	"./Kenya.png": 6422,
	"./Kiribati.png": 2653,
	"./Kuwait.png": 5975,
	"./Kyrgyzstan.png": 9708,
	"./Laos.png": 8975,
	"./Latvia.png": 7021,
	"./Lebanon.png": 3393,
	"./Lesotho.png": 6232,
	"./Liberia.png": 8288,
	"./Libya.png": 7361,
	"./Liechtenstein.png": 1377,
	"./Lithuania.png": 1275,
	"./Luxembourg.png": 9764,
	"./Macao.png": 5099,
	"./Macedonia.png": 3849,
	"./Madagascar.png": 5936,
	"./Malawi.png": 7287,
	"./Malaysia.png": 665,
	"./Maldives.png": 6219,
	"./Mali.png": 9059,
	"./Malta.png": 9389,
	"./Marshall_Islands.png": 965,
	"./Martinique.png": 8617,
	"./Mauritania.png": 944,
	"./Mauritius.png": 8223,
	"./Mexico.png": 7885,
	"./Micronesia.png": 3196,
	"./Moldova.png": 7622,
	"./Monaco.png": 5449,
	"./Mongolia.png": 9614,
	"./Montserrat.png": 7789,
	"./Morocco.png": 5396,
	"./Mozambique.png": 1570,
	"./Myanmar.png": 119,
	"./Namibia.png": 3517,
	"./Nauru.png": 2557,
	"./Nepal.png": 7924,
	"./Netherlands.png": 910,
	"./Netherlands_Antilles.png": 5855,
	"./New_Zealand.png": 6150,
	"./Nicaragua.png": 8471,
	"./Niger.png": 309,
	"./Nigeria.png": 7451,
	"./Niue.png": 5469,
	"./Norfolk_Island.png": 6441,
	"./North_Korea.png": 3540,
	"./Norway.png": 8442,
	"./Oman.png": 7481,
	"./Pakistan.png": 1609,
	"./Palau.png": 3539,
	"./Panama.png": 9496,
	"./Papua_New_Guinea.png": 4490,
	"./Paraguay.png": 776,
	"./Peru.png": 8342,
	"./Philippines.png": 1931,
	"./Pitcairn_Islands.png": 1035,
	"./Poland.png": 5568,
	"./Portugal.png": 4586,
	"./Puerto_Rico.png": 6181,
	"./Qatar.png": 2997,
	"./Republic_of_the_Congo.png": 5705,
	"./Romania.png": 5919,
	"./Russian_Federation.png": 5153,
	"./Rwanda.png": 6545,
	"./Saint_Kitts_and_Nevis.png": 5619,
	"./Saint_Lucia.png": 6898,
	"./Saint_Pierre.png": 689,
	"./Saint_Vicent_and_the_Grenadines.png": 7010,
	"./Samoa.png": 2295,
	"./San_Marino.png": 4705,
	"./Sao_Tomé_and_Príncipe.png": 888,
	"./Saudi_Arabia.png": 9165,
	"./Senegal.png": 2883,
	"./Serbia_and_Montenegro.png": 1635,
	"./Seychelles.png": 6165,
	"./Sierra_Leone.png": 3832,
	"./Singapore.png": 5628,
	"./Slovakia.png": 8836,
	"./Slovenia.png": 705,
	"./Soloman_Islands.png": 4918,
	"./Somalia.png": 5080,
	"./South_Africa.png": 592,
	"./South_Georgia.png": 1584,
	"./South_Korea.png": 3754,
	"./Soviet_Union.png": 3626,
	"./Spain.png": 5797,
	"./Sri_Lanka.png": 2898,
	"./Sudan.png": 4967,
	"./Suriname.png": 4658,
	"./Swaziland.png": 5837,
	"./Sweden.png": 8008,
	"./Switzerland.png": 7753,
	"./Syria.png": 1398,
	"./Taiwan.png": 4148,
	"./Tajikistan.png": 4226,
	"./Tanzania.png": 382,
	"./Thailand.png": 1853,
	"./Tibet.png": 832,
	"./Timor-Leste.png": 369,
	"./Togo.png": 4809,
	"./Tonga.png": 3093,
	"./Trinidad_and_Tobago.png": 2960,
	"./Tunisia.png": 6625,
	"./Turkey.png": 546,
	"./Turkmenistan.png": 7093,
	"./Turks_and_Caicos_Islands.png": 4753,
	"./Tuvalu.png": 1803,
	"./UAE.png": 7177,
	"./US_Virgin_Islands.png": 3345,
	"./Uganda.png": 2176,
	"./Ukraine.png": 8941,
	"./United_Kingdom.png": 5763,
	"./United_States_of_America.png": 9947,
	"./Uruguay.png": 4810,
	"./Uzbekistan.png": 1518,
	"./Vanuatu.png": 970,
	"./Vatican_City.png": 9526,
	"./Venezuela.png": 7963,
	"./Vietnam.png": 7230,
	"./Wallis_and_Futuna.png": 3978,
	"./Yemen.png": 1972,
	"./Zambia.png": 3120,
	"./Zimbabwe.png": 8347
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5163;